import { render, staticRenderFns } from "./personnel-recruit.vue?vue&type=template&id=2b1be754&scoped=true&"
import script from "./personnel-recruit.vue?vue&type=script&lang=js&"
export * from "./personnel-recruit.vue?vue&type=script&lang=js&"
import style0 from "./personnel-recruit.vue?vue&type=style&index=0&id=2b1be754&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1be754",
  null
  
)

export default component.exports